import React from 'react';
import { UserEdit } from 'iconsax-react';

type Props = {
  value: any;
  onEdit?: (id: any) => void;
  row?: any;
};

const TextEdit = ({ value, onEdit, row }: Props) => {
  const handleEdit = () => {
    if (onEdit && row) {
      onEdit(row.id);
    }
  };

  return (
    <div className="text-edit">
      {value || '-'}
      <div>
        <button
          onClick={handleEdit}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '0.25rem',
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            width: 'auto',
            minWidth: 'unset'
          }}
          title="Edit referral"
        >
          <UserEdit size="14" color="rgb(87, 59, 255)" />
        </button>
      </div>
    </div>
  );
};

export default TextEdit;
